import { ref, computed } from 'vue'

export function useAgeCalculation() {
  const day = ref<number | ''>('')
  const month = ref<number | ''>('')
  const year = ref<number | ''>('')

  const monthNames = [
    'Janeiro', 'Fevereiro', 'Março', 'Abril',
    'Maio', 'Junho', 'Julho', 'Agosto',
    'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ]

  const currentYear = new Date().getFullYear()
  const years = computed(() => {
    const years = []
    for (let y = currentYear - 18; y >= currentYear - 100; y--) {
      years.push(y)
    }
    return years
  })

  const age = computed(() => {
    if (!isValidDate.value) return null

    const birthDate = new Date(Number(year.value), Number(month.value) - 1, Number(day.value))
    const today = new Date()
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }

    return age
  })

  const isValidDate = computed(() => {
    if (!day.value || !month.value || !year.value) return false

    const date = new Date(Number(year.value), Number(month.value) - 1, Number(day.value))
    return date instanceof Date && !isNaN(date.getTime())
  })

  const initializeDate = () => {
    const today = new Date()
    const defaultDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate())

    day.value = defaultDate.getDate()
    month.value = defaultDate.getMonth() + 1
    year.value = defaultDate.getFullYear()
  }

  const formatDate = () => {
    if (!isValidDate.value) return ''

    const y = year.value
    const m = month.value.toString().padStart(2, '0')
    const d = day.value.toString().padStart(2, '0')

    return `${y}-${m}-${d}`
  }

  return {
    day,
    month,
    year,
    monthNames,
    years,
    age,
    isValidDate,
    initializeDate,
    formatDate
  }
}
